module.exports = __webpack_public_path__ + "static/media/21ECLAC29.20f293a6.jpg";